var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    zoomAndPan: "magnify",
    viewBox: "0 0 112.5 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "f7048de942"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.574219 0 L 110.445312 0 L 110.445312 29.03125 L 1.574219 29.03125 Z M 1.574219 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3e4c0a1b34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7 19 L 15 19 L 15 26.722656 L 7 26.722656 Z M 7 19 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e45fb12f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.488281 6 L 23 6 L 23 25 L 4.488281 25 Z M 4.488281 6 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a73e6424ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 2.664062 L 33 2.664062 L 33 10 L 25 10 Z M 25 2.664062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f333018480"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17 5 L 35.835938 5 L 35.835938 24 L 17 24 Z M 17 5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f7048de942)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 1.574219 0 L 110.925781 0 L 110.925781 36.453125 L 1.574219 36.453125 Z M 1.574219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 1.574219 0 L 110.925781 0 L 110.925781 29.160156 L 1.574219 29.160156 Z M 1.574219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 1.574219 0 L 110.925781 0 L 110.925781 29.160156 L 1.574219 29.160156 Z M 1.574219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3e4c0a1b34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004aad",
    d: "M 10.972656 19.503906 C 12.980469 19.503906 14.605469 21.117188 14.605469 23.109375 C 14.605469 25.101562 12.980469 26.71875 10.972656 26.71875 C 8.96875 26.71875 7.34375 25.101562 7.34375 23.109375 C 7.34375 21.117188 8.96875 19.503906 10.972656 19.503906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e45fb12f20)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004aad",
    d: "M 20.566406 12.441406 L 20.566406 20.9375 L 8.011719 13.738281 L 16.527344 8.855469 C 16.613281 8.804688 16.667969 8.714844 16.667969 8.613281 L 16.667969 6.5625 C 16.667969 6.347656 16.433594 6.210938 16.246094 6.320312 L 5.074219 12.726562 C 4.710938 12.9375 4.488281 13.320312 4.488281 13.738281 C 4.488281 14.15625 4.710938 14.542969 5.074219 14.75 L 21.152344 23.972656 C 21.335938 24.074219 21.539062 24.128906 21.742188 24.128906 C 21.945312 24.128906 22.144531 24.074219 22.328125 23.972656 C 22.691406 23.761719 22.914062 23.378906 22.914062 22.960938 L 22.914062 13.472656 C 22.914062 13.375 22.863281 13.28125 22.777344 13.230469 L 20.988281 12.199219 C 20.800781 12.09375 20.566406 12.226562 20.566406 12.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a73e6424ca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M 29.347656 9.882812 C 27.34375 9.882812 25.714844 8.265625 25.714844 6.273438 C 25.714844 4.28125 27.34375 2.664062 29.347656 2.664062 C 31.355469 2.664062 32.980469 4.28125 32.980469 6.273438 C 32.980469 8.265625 31.355469 9.882812 29.347656 9.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f333018480)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M 19.757812 16.941406 L 19.757812 8.445312 L 32.308594 15.644531 L 23.796875 20.527344 C 23.707031 20.578125 23.65625 20.671875 23.65625 20.769531 L 23.65625 22.820312 C 23.65625 23.035156 23.890625 23.171875 24.078125 23.0625 L 35.246094 16.65625 C 35.609375 16.449219 35.835938 16.0625 35.835938 15.644531 C 35.835938 15.226562 35.609375 14.84375 35.246094 14.632812 L 19.167969 5.410156 C 18.988281 5.308594 18.785156 5.253906 18.582031 5.253906 C 18.378906 5.253906 18.175781 5.308594 17.996094 5.410156 C 17.628906 5.621094 17.40625 6.003906 17.40625 6.421875 L 17.40625 15.910156 C 17.40625 16.007812 17.460938 16.101562 17.546875 16.152344 L 19.335938 17.183594 C 19.523438 17.289062 19.757812 17.15625 19.757812 16.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.261468, 19.929473)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.171875 0 L 5.101562 0 C 8.378906 0 11.058594 -2.660156 11.058594 -5.957031 C 11.058594 -9.253906 8.378906 -11.914062 5.101562 -11.914062 L 1.171875 -11.914062 Z M 3.792969 -2.324219 L 3.792969 -9.589844 L 5.082031 -9.589844 C 6.96875 -9.589844 8.4375 -8.019531 8.4375 -5.957031 C 8.4375 -3.890625 6.96875 -2.324219 5.082031 -2.324219 Z M 3.792969 -2.324219 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.75287, 19.929473)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.269531 0 L 3.890625 0 L 3.890625 -11.914062 L 1.269531 -11.914062 Z M 1.269531 0 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.593674, 19.929473)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.339844 -11.914062 L 5.5 -3.394531 L 2.660156 -11.914062 L -0.257812 -11.914062 L 4.03125 0 L 6.96875 0 L 11.257812 -11.914062 Z M 8.339844 -11.914062 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.290974, 19.929473)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.4375 -9.609375 L 8.4375 -11.914062 L 1.269531 -11.914062 L 1.269531 0 L 8.4375 0 L 8.4375 -2.304688 L 3.890625 -2.304688 L 3.890625 -4.804688 L 7.785156 -4.804688 L 7.785156 -7.109375 L 3.890625 -7.109375 L 3.890625 -9.609375 Z M 8.4375 -9.609375 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.241252, 19.929473)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.386719 -4.902344 C 8.796875 -5.320312 9.789062 -6.632812 9.789062 -8.257812 C 9.789062 -10.285156 8.28125 -11.914062 6.234375 -11.914062 L 1.171875 -11.914062 L 1.171875 0 L 3.792969 0 L 3.792969 -4.605469 L 4.84375 -4.605469 L 7.785156 0 L 10.722656 0 Z M 5.835938 -6.769531 L 3.792969 -6.769531 L 3.792969 -9.589844 L 5.835938 -9.589844 C 6.671875 -9.589844 7.285156 -8.996094 7.285156 -8.179688 C 7.285156 -7.347656 6.671875 -6.769531 5.835938 -6.769531 Z M 5.835938 -6.769531 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.561349, 19.929473)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.84375 0.160156 C 7.070312 0.160156 8.953125 -1.152344 8.953125 -3.375 C 8.953125 -7.785156 3.476562 -6.691406 3.476562 -8.757812 C 3.476562 -9.429688 3.992188 -9.75 4.625 -9.75 C 5.300781 -9.75 5.976562 -9.371094 6.570312 -8.714844 L 8.320312 -10.382812 C 7.445312 -11.398438 6.117188 -12.070312 4.644531 -12.070312 C 2.761719 -12.070312 0.832031 -10.941406 0.832031 -8.558594 C 0.832031 -4.507812 6.332031 -5.480469 6.332031 -3.394531 C 6.332031 -2.738281 5.777344 -2.304688 4.863281 -2.304688 C 3.773438 -2.304688 2.917969 -2.917969 2.480469 -3.851562 L 0.316406 -2.5 C 1.09375 -1.011719 2.761719 0.160156 4.84375 0.160156 Z M 4.84375 0.160156 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.670443, 19.929473)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.4375 -9.609375 L 8.4375 -11.914062 L 1.269531 -11.914062 L 1.269531 0 L 8.4375 0 L 8.4375 -2.304688 L 3.890625 -2.304688 L 3.890625 -4.804688 L 7.785156 -4.804688 L 7.785156 -7.109375 L 3.890625 -7.109375 L 3.890625 -9.609375 Z M 8.4375 -9.609375 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.49432b48caf23e90a22dc790ed63e1b9.svg";
export { ForwardRef as ReactComponent };